import React, { SFC } from 'react';
import { IllustrationMerchantLogoHorizontal } from '@grpn/mx-components';
import LanguageSelector from '../language-selector/language-selector';
import classNames from 'classnames';
import styles from './header.module.styl';
import { I18n, setLanguage, getAvailableLanguages } from '../../../helpers/i18n';

const Header: SFC = () => (
  <header className={classNames('mx-header', styles.header)}>
    <div className={classNames('row', styles.fullHeight)}>
      <div className={classNames('md-column sm-column--2of3', styles.verticalCenter)}>
        <a href="/merchant">
          <IllustrationMerchantLogoHorizontal height={16} widht="auto" />
        </a>
      </div>
      <div
        className={classNames(
          'md-column sm-column--1of3 text-right',
          styles.verticalCenter,
          styles.contentRight,
        )}
      >
        {getLanguageSwitcher()}
      </div>
    </div>
  </header>
);

const getLanguageSwitcher = () => {
  const availableLanguageOptions = getAvailableLanguages();
  if (availableLanguageOptions.length > 0) {
    return (
      <LanguageSelector
        onLanguageChange={setLanguage}
        currentLanguage={I18n.locale}
        languageOptions={availableLanguageOptions}
      />
    );
  }
  return null;
};

export default Header;
